import { useEffect, useState } from 'react';
import { tableHeader, tableData, title } from '../utils/style';
import { url } from '../utils/config';
import axios from 'axios';
import Table from '../reusable_components/Table';
import moment from 'moment';

function UpcomingAppointments() {

    const options = [
        {
            header: 'DATE',
            key: 'date',
            placeHolder: 'mm-dd-yyyy'
        },
        {
            header: 'TIME SLOT',
            key: 'time',
        },
        {
            header: 'Problem Description',
            key: 'problemDescription',
        },
        {
            header: 'VEHICLE INFO',
            render: (data) => { if (data['make']) return `${data['make']} - ${data['model']} - ${data['year']}` },
        },
        {
            header: 'ASSIGNED TO',
            render: (data) => {
                if (data['technician']['firstName']) return `${data['technician']['firstName'] + " " + data['technician']['lastName'] || ''}`
            },
        }
    ]

    const excludeFilter = ['VEHICLE INFO', 'ASSIGNED TO']

    return (
        <div className="p-4">
            <div className={`${title} mb-4`}>Upcoming Appointments</div>

            <Table
                options={options}
                url={url + '/upcoming_appointments'}
                pagination
                noButton
                excludeFilter={excludeFilter}
            />
        </div>
    )
}

export default UpcomingAppointments;